import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_285: DocMigration = {
  maxSchemaVersion: "0.0.285",
  description: "Ensure that entityType is set for facade span & sweep strata",
  apply(json: any): any {
    for (const id in json.facadeSpanStrata) {
      json.facadeSpanStrata[id] = {
        ...json.facadeSpanStrata[id],
        entityType: "FACADE_SPAN_STRATUM",
      };
    }

    for (const id in json.facadeSweepStrata) {
      json.facadeSweepStrata[id] = {
        ...json.facadeSweepStrata[id],
        entityType: "FACADE_SWEEP_STRATUM",
      };
    }

    return json;
  },
};

export default migration_0_0_285;
